exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "ul[data-v-3de8ce65]{margin:0}ul.notebook li[data-v-3de8ce65]{margin:0;list-style:none;width:100%;background-color:#fff;border-top:1px solid #ccc;border-bottom:1px solid #999;padding:10px 20px;text-align:left;cursor:pointer}ul.notebook li span[data-v-3de8ce65]{display:inline-block}.notebook-message[data-v-3de8ce65]{margin:20px}.date[data-v-3de8ce65],.note[data-v-3de8ce65]{font-size:smaller}.title[data-v-3de8ce65]{margin-bottom:8px}.note[data-v-3de8ce65]{margin-top:8px;max-width:100%;overflow:hidden;text-overflow:ellipsis;white-space:nowrap}.geocoords[data-v-3de8ce65],.place[data-v-3de8ce65]{float:right;font-size:smaller;width:60%;overflow:hidden;text-overflow:ellipsis;white-space:nowrap}.geocoords[data-v-3de8ce65]{color:#4e7eef}.location-icon[data-v-3de8ce65]{fill:#4e7eef}.place[data-v-3de8ce65]{color:#666}.place-icon[data-v-3de8ce65]{fill:#ed453b}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-3de8ce65","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/Notebook.vue
// module id = 185
// module chunks = 0